export class AppConfigurationsKeys {
  static welcomeVideoUrlWebKey = 'App.Web.Welcome.Video.URL';
  static agreementSalesEnKey = 'Core.Asset.Agreement.Sales.EN';
  static agreementSalesTrKey = 'Core.Asset.Agreement.Sales.TR';
  static agreementTermsEnKey = 'Core.Asset.Agreement.Terms.EN';
  static agreementTermsTrKey = 'Core.Asset.Agreement.Terms.TR';
  static googleAndroidClientIdKey = 'Core.Google.Android.ClientId';
  static googleAndroidProjectIdKey = 'Core.Google.Android.ProjectId';
  static googleIosClientIdKey = 'Core.Google.iOS.ClientId';
  static googleIosProjectIdKey = 'Core.Google.iOS.ProjectId';
  static facebookAppIdKey = 'Core.Facebook.AppId';
  static facebookAppSecretKey = 'Core.Facebook.AppSecret';
  static appHeaderXAppWebKey = 'App.Header.XApp.Web';
}